import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { filterGames, updateUmpAvailableForGame } from '../actions/gamesActions';
import { getUmpInfo, assignUmpToGame, removeUmp } from '../actions/umpireActions';
import { getSeasonDivisions } from '../actions/divisionsActions';
import { getTeams } from '../actions/teamActions';
import GamesList from '../components/GamesListV2';

const mapDispatchToProps = dispatch => {
  return {
    filterGames: (startDate, endDate, season, division, team, umpire, showAllGames, limitResults) => {
      dispatch(filterGames(startDate, endDate, season, division, team, umpire, showAllGames, limitResults));
    },
    updateUmpAvailableForGame: (gameId, umpAvailable) => {
      dispatch(updateUmpAvailableForGame(gameId, umpAvailable));
    },
    removeUmp: (umpireId, gameId, plate, updatedGame) => {
      dispatch(removeUmp(umpireId, gameId, plate, updatedGame));
    },
    assignUmpToGame: (umpireId, gameId, plate, updatedGame) => {
      dispatch(assignUmpToGame(umpireId, gameId, plate, updatedGame));
    },
    getUmpInfo: memberId => {
      dispatch(getUmpInfo(memberId));
    },
    getSeasonDivisions: (seasonId) => {
      dispatch(getSeasonDivisions(seasonId));
    },
    getTeams: (divisionId, seasonId) => {
      dispatch(getTeams(divisionId, seasonId));
    }
  };
};

const mapStateToProps = state => ({
  games: state.games.games,
  filteredGamesList: state.games.filteredGamesList,
  fetchingFilteredGamesStatus: state.games.fetchingFilteredGamesStatus,
  memberId: state.user.memberId,
  userType: state.user.userType,
  umpires: state.umpires.umpires,
  umpiresList: state.umpires.umpiresList,
  fetchingUmpiresStatus: state.umpires.fetchingStatus,
  updatedGame: state.games.updatedGame,
  teams: state.teams.teams,
  teamsList: state.teams.teamsList,
  fetchingTeamsStatus: state.teams.fetchingTeamsStatus,
  seasonDivisions: state.divisions.seasonDivisions,
  seasonDivisionsList: state.divisions.seasonDivisionsList,
  fetchingSeasonDivisionsStatus: state.divisions.fetchingSeasonDivisionsStatus,
  userSeason: state.user.userSeason
});

const GamesListContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(GamesList));
export default GamesListContainer;



// WEBPACK FOOTER //
// ./src/containers/GamesListContainer.js